import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  imageRecognition: generateApiPath({ prefix: AuthLevel.AUTH, name: 'image-recognition' }),
}

export { paths }
